/* tslint:disable */
/* eslint-disable */
/**
 * Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CommercePlatformCartServiceControllersSharedResponsesPingCodebaseInformationResponse
 */
export interface CommercePlatformCartServiceControllersSharedResponsesPingCodebaseInformationResponse {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceControllersSharedResponsesPingCodebaseInformationResponse
     */
    'buildConfiguration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceControllersSharedResponsesPingCodebaseInformationResponse
     */
    'branch'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceControllersSharedResponsesPingCodebaseInformationResponse
     */
    'hash'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsAliasType}
     * @memberof CommercePlatformCartServiceControllersSharedResponsesPingCodebaseInformationResponse
     */
    'alias'?: CommercePlatformCartServiceModelsAliasType;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
 */
export interface CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'sku'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'productId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'artworkId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'minimumWidth'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'maximumWidth'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'minimumHeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'maximumHeight'?: number | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsCartStatusCode}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'code'?: CommercePlatformCartServiceModelsCartStatusCode;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'displayQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'netQuantity'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult
     */
    'isValidRequest'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsAliasType = {
    PreProd: 'PreProd',
    Prod: 'Prod'
} as const;

export type CommercePlatformCartServiceModelsAliasType = typeof CommercePlatformCartServiceModelsAliasType[keyof typeof CommercePlatformCartServiceModelsAliasType];


/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsCartStatusCode = {
    Unknown: 'Unknown',
    MinimumQuantity: 'MinimumQuantity',
    MaximumQuantityInWarehouse: 'MaximumQuantityInWarehouse',
    MaximumQuantityInTransit: 'MaximumQuantityInTransit',
    DynamicDimensionsWidth: 'DynamicDimensionsWidth',
    DynamicDimensionsHeight: 'DynamicDimensionsHeight',
    MinimumOrderQuantity: 'MinimumOrderQuantity',
    BackOrder: 'BackOrder',
    HardMinimum: 'HardMinimum',
    DuplicateItems: 'DuplicateItems',
    InvalidQuantity: 'InvalidQuantity'
} as const;

export type CommercePlatformCartServiceModelsCartStatusCode = typeof CommercePlatformCartServiceModelsCartStatusCode[keyof typeof CommercePlatformCartServiceModelsCartStatusCode];


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO
     */
    'token'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO
     */
    'recovered'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO
     */
    'ip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO
     */
    'created'?: string;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'token'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {GPAWebDataTypesPaymentOptionType}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'type'?: GPAWebDataTypesPaymentOptionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'numberMasked'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'month'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'postal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'lastUsed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'deleted'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO
     */
    'isExpired'?: boolean;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicAccountDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicAccountDTO {
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'addresses'?: Array<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO> | null;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'payments'?: Array<CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO> | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'hsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'cartId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'defaultAddressId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'defaultPaymentId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'first'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'last'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'abbreviatedName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'industry'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'isVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'updated'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'lastLogin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'passwordChanged'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'verified'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountDTO
     */
    'thirdPartyShip'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'hsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'cartId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'defaultAddressId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'defaultPaymentId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'first'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'last'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'abbreviatedName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'industry'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'isVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'updated'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'lastLogin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'passwordChanged'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'verified'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO
     */
    'thirdPartyShip'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'catalogId'?: number;
    /**
     * 
     * @type {CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'classificationType'?: CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsVerificationType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'verificationType'?: CommercePlatformCartServiceModelsVerificationType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'first'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'last'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'address1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'stateProvince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'postal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'extension'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'shippingEligible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO
     */
    'updated'?: string | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicCartDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicCartDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'shipping'?: CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'billing'?: CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'groups'?: Array<CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO> | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'resourcesTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'hsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'catalogId'?: number;
    /**
     * 
     * @type {GPAWebDataTypesResponsibilityCenter}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'responsibilityCenter'?: GPAWebDataTypesResponsibilityCenter;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'shippingId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'billingId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'paymentId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'itemsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'taxTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'shipTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'orderTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'taxCertificateId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'promotionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsPromotionType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'promotionType'?: CommercePlatformCartServiceModelsPromotionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'promotionCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'promotionTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'orderNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'purchaseOrderNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'shipMethod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'shipPostal'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'allowShipPartial'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'thirdPartyShipCarrier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'thirdPartyShipAccount'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'readOnly'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'smsPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'ip'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'internal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'isLocalPickup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'isThirdParty'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartDTO
     */
    'checkoutHash'?: string | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'cart'?: CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicCartItemDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'items'?: Array<CommercePlatformCartServiceModelsDTOsPublicCartItemDTO> | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'netPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'resourcesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'aggregateQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'cartId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'Sku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO
     */
    'updated'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO
     */
    'cartId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO
     */
    'Sku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO
     */
    'updated'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicCartItemDTO {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'promotionTotal'?: number;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'group'?: CommercePlatformCartServiceModelsDTOsPublicCartGroupDTO;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'resources'?: Array<CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO> | null;
    /**
     * Design services are mapped one per item, warranties are mapped one per quantity
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'resourcesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'artworkId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'unitPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'netPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'updated'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'artworkId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'unitPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'netPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'updated'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO
     */
    'group'?: CommercePlatformCartServiceModelsDTOsPublicCartGroupMiniDTO;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'item'?: CommercePlatformCartServiceModelsDTOsPublicCartItemMiniDTO;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'id'?: number;
    /**
     * 
     * @type {GPAWebDataTypesResourceType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'type'?: GPAWebDataTypesResourceType;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'cartItemId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'resourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'updated'?: string | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'hsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'catalogId'?: number;
    /**
     * 
     * @type {GPAWebDataTypesResponsibilityCenter}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'responsibilityCenter'?: GPAWebDataTypesResponsibilityCenter;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'shippingId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'billingId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'paymentId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'itemsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'resourcesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'taxTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'shipTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'orderTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'taxCertificateId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'promotionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsPromotionType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'promotionType'?: CommercePlatformCartServiceModelsPromotionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'promotionCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'promotionTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'orderNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'purchaseOrderNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'shipMethod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'shipPostal'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'allowShipPartial'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'thirdPartyShipCarrier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'thirdPartyShipAccount'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'readOnly'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'smsPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'ip'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'internal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'isLocalPickup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'isThirdParty'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO
     */
    'checkoutHash'?: string | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicChangeDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicChangeDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsEvaluationStatus}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicChangeDTO
     */
    'evaluationStatus'?: CommercePlatformCartServiceModelsEvaluationStatus;
    /**
     * 
     * @type {any}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicChangeDTO
     */
    'originalValue'?: any | null;
    /**
     * 
     * @type {any}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicChangeDTO
     */
    'newValue'?: any | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicCartItemDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'item'?: CommercePlatformCartServiceModelsDTOsPublicCartItemDTO;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicChangeDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemDTO
     */
    'changes'?: Array<CommercePlatformCartServiceModelsDTOsPublicChangeDTO> | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'item'?: CommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicChangeDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO
     */
    'changes'?: Array<CommercePlatformCartServiceModelsDTOsPublicChangeDTO> | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicOperationDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicOperationDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsJsonPatchOperationType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOperationDTO
     */
    'op': CommercePlatformCartServiceModelsJsonPatchOperationType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOperationDTO
     */
    'path': string;
    /**
     * 
     * @type {any}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOperationDTO
     */
    'value'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOperationDTO
     */
    'from'?: string | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicOrderDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicOrderDTO {
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'groups'?: Array<CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO> | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'itemsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'resourcesTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'orderNumber'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsOrderStatus}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'status'?: CommercePlatformCartServiceModelsOrderStatus;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'hsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'cartId'?: string;
    /**
     * 
     * @type {GPAWebDataTypesResponsibilityCenter}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'responsibilityCenter'?: GPAWebDataTypesResponsibilityCenter;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'paymentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingFirst'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingLast'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingAddress1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingAddress2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingStateProvince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingPostal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingPhone'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsVerificationType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shippingVerificationType'?: CommercePlatformCartServiceModelsVerificationType;
    /**
     * 
     * @type {CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shipAddressClassification'?: CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingFirst'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingLast'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingAddress1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingAddress2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingStateProvince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingPostal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'billingPhone'?: string | null;
    /**
     * 
     * @type {GPAWebDataTypesPaymentOptionType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'paymentType'?: GPAWebDataTypesPaymentOptionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'cardName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'cardNumberMasked'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'expirationMonth'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'expirationYear'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'cardAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'cardPostal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'taxTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shipTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsPromotionType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'promotionType'?: CommercePlatformCartServiceModelsPromotionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'promotionCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'promotionTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'purchaseOrderNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'shipMethod'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'allowShipPartial'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'thirdPartyShipCarrier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'thirdPartyShipAccount'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'taxExempt'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'taxExemptCertificateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'ip'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'internal'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'promotionRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'orderTotal'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'isLocalPickup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'isThirdParty'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'transferred'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'transactionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'externalReferenceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'transactionStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderDTO
     */
    'smsPhone'?: string | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'order'?: CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'items'?: Array<CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO> | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'netPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'resourcesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'aggregateQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'orderNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO
     */
    'Sku'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'promotionTotal'?: number;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'group'?: CommercePlatformCartServiceModelsDTOsPublicOrderGroupDTO;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO>}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'resources'?: Array<CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO> | null;
    /**
     * Design services are mapped one per item, warranties are mapped one per quantity
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'resourcesTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'artworkId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'unitPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'netPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemDTO
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
     */
    'artworkId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
     */
    'height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
     */
    'unitPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
     */
    'netPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO
     */
    'item'?: CommercePlatformCartServiceModelsDTOsPublicOrderItemMiniDTO;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO
     */
    'id'?: number;
    /**
     * 
     * @type {GPAWebDataTypesResourceType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO
     */
    'type'?: GPAWebDataTypesResourceType;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO
     */
    'orderItemId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO
     */
    'resourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderItemResourceDTO
     */
    'price'?: number;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'orderNumber'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsOrderStatus}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'status'?: CommercePlatformCartServiceModelsOrderStatus;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'hsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'cartId'?: string;
    /**
     * 
     * @type {GPAWebDataTypesResponsibilityCenter}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'responsibilityCenter'?: GPAWebDataTypesResponsibilityCenter;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'paymentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingFirst'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingLast'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingAddress1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingAddress2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingStateProvince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingPostal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingPhone'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsVerificationType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shippingVerificationType'?: CommercePlatformCartServiceModelsVerificationType;
    /**
     * 
     * @type {CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shipAddressClassification'?: CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingCompany'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingFirst'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingLast'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingAddress1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingAddress2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingStateProvince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingPostal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'billingPhone'?: string | null;
    /**
     * 
     * @type {GPAWebDataTypesPaymentOptionType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'paymentType'?: GPAWebDataTypesPaymentOptionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'cardName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'cardNumberMasked'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'expirationMonth'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'expirationYear'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'cardAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'cardPostal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'taxTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shipTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsPromotionType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'promotionType'?: CommercePlatformCartServiceModelsPromotionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'promotionCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'promotionTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'purchaseOrderNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'shipMethod'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'allowShipPartial'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'thirdPartyShipCarrier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'thirdPartyShipAccount'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'taxExempt'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'taxExemptCertificateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'ip'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'internal'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'promotionRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'orderTotal'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'isLocalPickup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'isThirdParty'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'transferred'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'transactionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'externalReferenceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'transactionStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicOrderMiniDTO
     */
    'smsPhone'?: string | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {GPAWebDataTypesPaymentOptionType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'type'?: GPAWebDataTypesPaymentOptionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'numberMasked'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'month'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'postal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'lastUsed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'deleted'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO
     */
    'isExpired'?: boolean;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsShippingOptionType}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'type'?: CommercePlatformCartServiceModelsShippingOptionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'originalRate'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'isFreight'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'transitDays'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'hasArrivalDateRange'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'arrivalDateMinimum'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO
     */
    'arrivalDateMaximum'?: string | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsDTOsPublicTaxRegionDTO
 */
export interface CommercePlatformCartServiceModelsDTOsPublicTaxRegionDTO {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicTaxRegionDTO
     */
    'postal'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicTaxRegionDTO
     */
    'rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicTaxRegionDTO
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicTaxRegionDTO
     */
    'stateProvinceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsDTOsPublicTaxRegionDTO
     */
    'countryCode'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsEvaluationStatus = {
    Default: 'Default',
    Quantity: 'Quantity',
    Price: 'Price'
} as const;

export type CommercePlatformCartServiceModelsEvaluationStatus = typeof CommercePlatformCartServiceModelsEvaluationStatus[keyof typeof CommercePlatformCartServiceModelsEvaluationStatus];


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsEvaluationsCartItemEvaluation
 */
export interface CommercePlatformCartServiceModelsEvaluationsCartItemEvaluation {
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemDTO>}
     * @memberof CommercePlatformCartServiceModelsEvaluationsCartItemEvaluation
     */
    'alteredCartItems'?: Array<CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemDTO> | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsEvaluationsCartItemResourcesEvaluation
 */
export interface CommercePlatformCartServiceModelsEvaluationsCartItemResourcesEvaluation {
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO>}
     * @memberof CommercePlatformCartServiceModelsEvaluationsCartItemResourcesEvaluation
     */
    'alteredCartItemResources'?: Array<CommercePlatformCartServiceModelsDTOsPublicChangeDTOCommercePlatformCartServiceModelsDTOsPublicCartItemResourceDTO> | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation
 */
export interface CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsPromotionEvaluationStatus}
     * @memberof CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation
     */
    'status'?: CommercePlatformCartServiceModelsPromotionEvaluationStatus;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation
     */
    'number'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsPromotionType}
     * @memberof CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation
     */
    'type'?: CommercePlatformCartServiceModelsPromotionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation
     */
    'end'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation
     */
    'minAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation
     */
    'minQuantity'?: number | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsEvaluationsShippingEvaluation
 */
export interface CommercePlatformCartServiceModelsEvaluationsShippingEvaluation {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsEvaluationsShippingEvaluation
     */
    'method'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsEvaluationsShippingEvaluation
     */
    'description'?: string | null;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsShippingEvaluationStatus}
     * @memberof CommercePlatformCartServiceModelsEvaluationsShippingEvaluation
     */
    'status'?: CommercePlatformCartServiceModelsShippingEvaluationStatus;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsEvaluationsShippingEvaluation
     */
    'amount'?: number;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsEvaluationsTaxEvaluation
 */
export interface CommercePlatformCartServiceModelsEvaluationsTaxEvaluation {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsEvaluationsTaxEvaluation
     */
    'amount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsEvaluationsTaxEvaluation
     */
    'exempt'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsJsonPatchOperationType = {
    Unknown: 'Unknown',
    Add: 'Add',
    Remove: 'Remove',
    Replace: 'Replace',
    Copy: 'Copy',
    Move: 'Move',
    Test: 'Test'
} as const;

export type CommercePlatformCartServiceModelsJsonPatchOperationType = typeof CommercePlatformCartServiceModelsJsonPatchOperationType[keyof typeof CommercePlatformCartServiceModelsJsonPatchOperationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsOrderStatus = {
    Unknown: 'Unknown',
    Refunded: 'Refunded',
    Cancelled: 'Cancelled',
    Invoiced: 'Invoiced',
    Processing: 'Processing',
    Picked: 'Picked',
    Shipped: 'Shipped',
    Delivered: 'Delivered',
    PartiallyShipped: 'PartiallyShipped',
    Paid: 'Paid'
} as const;

export type CommercePlatformCartServiceModelsOrderStatus = typeof CommercePlatformCartServiceModelsOrderStatus[keyof typeof CommercePlatformCartServiceModelsOrderStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsPromotionEvaluationStatus = {
    Unknown: 'Unknown',
    Valid: 'Valid',
    Invalid: 'Invalid',
    Expired: 'Expired',
    NotStarted: 'NotStarted',
    DoesntApplyItems: 'DoesntApplyItems',
    UnderMinimumOrderValue: 'UnderMinimumOrderValue',
    NotEligible: 'NotEligible',
    Redeemed: 'Redeemed'
} as const;

export type CommercePlatformCartServiceModelsPromotionEvaluationStatus = typeof CommercePlatformCartServiceModelsPromotionEvaluationStatus[keyof typeof CommercePlatformCartServiceModelsPromotionEvaluationStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsPromotionType = {
    Unknown: 'Unknown',
    SingleProduct: 'SingleProduct',
    ProductGroup: 'ProductGroup',
    SingleUseCode: 'SingleUseCode'
} as const;

export type CommercePlatformCartServiceModelsPromotionType = typeof CommercePlatformCartServiceModelsPromotionType[keyof typeof CommercePlatformCartServiceModelsPromotionType];


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest
 */
export interface CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest
 */
export interface CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest
     */
    'first'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest
     */
    'last'?: string | null;
    /**
     * 
     * @type {GPAWebDataTypesIndustryType}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest
     */
    'industry'?: GPAWebDataTypesIndustryType;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
 */
export interface CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest {
    /**
     * 
     * @type {CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'classificationType': CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsVerificationType}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'verificationType': CommercePlatformCartServiceModelsVerificationType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'first': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'last': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'address1': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'stateProvince': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'postal': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'extension'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'default': boolean;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'catalogId': number;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest
     */
    'shippingEligible'?: boolean;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
 */
export interface CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
     */
    'id'?: number | null;
    /**
     * 
     * @type {GPAWebDataTypesPaymentOptionType}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
     */
    'type'?: GPAWebDataTypesPaymentOptionType;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
     */
    'numberMasked'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
     */
    'token'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
     */
    'month'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest
     */
    'postal'?: string | null;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest
 */
export interface CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest
     */
    'accountId': number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest
     */
    'tokenSalt': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest
     */
    'clientIp': string;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest
 */
export interface CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest
 */
export interface CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest
     */
    'currentPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest
     */
    'newPassword'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsCartAddItemRequest
 */
export interface CommercePlatformCartServiceModelsRequestsCartAddItemRequest {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemRequest
     */
    'productId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemRequest
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemRequest
     */
    'artworkId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemRequest
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemRequest
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemRequest
     */
    'resourceId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemRequest
     */
    'resourcePrice'?: number | null;
    /**
     * 
     * @type {GPAWebDataTypesResourceType}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemRequest
     */
    'resourceType'?: GPAWebDataTypesResourceType;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest
 */
export interface CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest
     */
    'productId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest
     */
    'artworkId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest
     */
    'height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest
     */
    'resourceId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest
     */
    'resourcePrice'?: number | null;
    /**
     * 
     * @type {GPAWebDataTypesResourceType}
     * @memberof CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest
     */
    'resourceType'?: GPAWebDataTypesResourceType;
}


/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsCartCreateRequest
 */
export interface CommercePlatformCartServiceModelsRequestsCartCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartCreateRequest
     */
    'hsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartCreateRequest
     */
    'catalogId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartCreateRequest
     */
    'accountId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsCartCreateRequest
     */
    'currencyCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsRequestsCartCreateRequest
     */
    'allowShipPartial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsRequestsCartCreateRequest
     */
    'internal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsCartCreateRequest
     */
    'ip'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest
 */
export interface CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest
     */
    'id': number;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicOperationDTO>}
     * @memberof CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest
     */
    'operations': Array<CommercePlatformCartServiceModelsDTOsPublicOperationDTO>;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest
 */
export interface CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest {
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicCartDTO}
     * @memberof CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest
     */
    'cartDTO'?: CommercePlatformCartServiceModelsDTOsPublicCartDTO;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest
     */
    'transactionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest
     */
    'externalReferenceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest
     */
    'transactionStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest
     */
    'transactionMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsResponsesAccountCreateAccountResponse
 */
export interface CommercePlatformCartServiceModelsResponsesAccountCreateAccountResponse {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsResponsesAccountCreateAccountResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsResponsesAccountCreateAccountResponse
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsResponsesAccountCreateRecoveryResponse
 */
export interface CommercePlatformCartServiceModelsResponsesAccountCreateRecoveryResponse {
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsResponsesAccountCreateRecoveryResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformCartServiceModelsResponsesAccountCreateRecoveryResponse
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsResponsesCartCartResponse
 */
export interface CommercePlatformCartServiceModelsResponsesCartCartResponse {
    /**
     * 
     * @type {object}
     * @memberof CommercePlatformCartServiceModelsResponsesCartCartResponse
     */
    'cartEvaluation': object;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicCartDTO}
     * @memberof CommercePlatformCartServiceModelsResponsesCartCartResponse
     */
    'cart': CommercePlatformCartServiceModelsDTOsPublicCartDTO;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation}
     * @memberof CommercePlatformCartServiceModelsResponsesCartCartResponse
     */
    'promotionEvaluation': CommercePlatformCartServiceModelsEvaluationsPromotionEvaluation;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsEvaluationsTaxEvaluation}
     * @memberof CommercePlatformCartServiceModelsResponsesCartCartResponse
     */
    'taxEvaluation': CommercePlatformCartServiceModelsEvaluationsTaxEvaluation;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsEvaluationsShippingEvaluation}
     * @memberof CommercePlatformCartServiceModelsResponsesCartCartResponse
     */
    'shippingEvaluation': CommercePlatformCartServiceModelsEvaluationsShippingEvaluation;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsEvaluationsCartItemEvaluation}
     * @memberof CommercePlatformCartServiceModelsResponsesCartCartResponse
     */
    'productsEvaluation': CommercePlatformCartServiceModelsEvaluationsCartItemEvaluation;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsEvaluationsCartItemResourcesEvaluation}
     * @memberof CommercePlatformCartServiceModelsResponsesCartCartResponse
     */
    'productResourcesEvaluation': CommercePlatformCartServiceModelsEvaluationsCartItemResourcesEvaluation;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult>}
     * @memberof CommercePlatformCartServiceModelsResponsesCartCartResponse
     */
    'cartStatusCodes': Array<CommercePlatformCartServiceControllersV1ValidatorsCartStatusCodeResult>;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse
 */
export interface CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse {
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse
     */
    'serviceBuffer'?: number;
    /**
     * 
     * @type {CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO}
     * @memberof CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse
     */
    'bestValue'?: CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO;
    /**
     * 
     * @type {Array<CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO>}
     * @memberof CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse
     */
    'shippingOptions'?: Array<CommercePlatformCartServiceModelsDTOsPublicShippingOptionDTO> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse
     */
    'shipPartial'?: boolean;
    /**
     * All items are in stock and have 0 day lead times
     * @type {boolean}
     * @memberof CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse
     */
    'quickShip'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse
     */
    'serviceDays'?: number;
}
/**
 * 
 * @export
 * @interface CommercePlatformCartServiceModelsResponsesShippingAddressValidationResponse
 */
export interface CommercePlatformCartServiceModelsResponsesShippingAddressValidationResponse {
    /**
     * 
     * @type {CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification}
     * @memberof CommercePlatformCartServiceModelsResponsesShippingAddressValidationResponse
     */
    'classification'?: CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification;
    /**
     * 
     * @type {Array<CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress>}
     * @memberof CommercePlatformCartServiceModelsResponsesShippingAddressValidationResponse
     */
    'resolvedAddresses'?: Array<CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress> | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsShippingEvaluationStatus = {
    Unknown: 'Unknown',
    Valid: 'Valid',
    Invalid: 'Invalid'
} as const;

export type CommercePlatformCartServiceModelsShippingEvaluationStatus = typeof CommercePlatformCartServiceModelsShippingEvaluationStatus[keyof typeof CommercePlatformCartServiceModelsShippingEvaluationStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsShippingOptionType = {
    Ground: 'Ground',
    OneDay: 'OneDay',
    TwoDay: 'TwoDay',
    ThreeDay: 'ThreeDay',
    ThirdParty: 'ThirdParty',
    LocalPickup: 'LocalPickup',
    Unknown: 'Unknown'
} as const;

export type CommercePlatformCartServiceModelsShippingOptionType = typeof CommercePlatformCartServiceModelsShippingOptionType[keyof typeof CommercePlatformCartServiceModelsShippingOptionType];


/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformCartServiceModelsVerificationType = {
    Unknown: 'UNKNOWN',
    Customer: 'CUSTOMER',
    Carrier: 'CARRIER'
} as const;

export type CommercePlatformCartServiceModelsVerificationType = typeof CommercePlatformCartServiceModelsVerificationType[keyof typeof CommercePlatformCartServiceModelsVerificationType];


/**
 * 
 * @export
 * @interface CommercePlatformOpenAPIClientsFedExAddressValidationParsedPostalCode
 */
export interface CommercePlatformOpenAPIClientsFedExAddressValidationParsedPostalCode {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationParsedPostalCode
     */
    'base'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationParsedPostalCode
     */
    'addOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationParsedPostalCode
     */
    'deliveryPoint'?: string;
}
/**
 * 
 * @export
 * @interface CommercePlatformOpenAPIClientsFedExAddressValidationResolutionToken
 */
export interface CommercePlatformOpenAPIClientsFedExAddressValidationResolutionToken {
    [key: string]: any;

    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolutionToken
     */
    'changed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolutionToken
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
 */
export interface CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress {
    [key: string]: any;

    /**
     * 
     * @type {Array<string>}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'streetLinesToken'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'stateOrProvinceCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'countryCode'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'customerMessage'?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<CommercePlatformOpenAPIClientsFedExAddressValidationResolutionToken>}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'cityToken'?: Array<CommercePlatformOpenAPIClientsFedExAddressValidationResolutionToken>;
    /**
     * 
     * @type {CommercePlatformOpenAPIClientsFedExAddressValidationResolutionToken}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'postalCodeToken'?: CommercePlatformOpenAPIClientsFedExAddressValidationResolutionToken;
    /**
     * 
     * @type {CommercePlatformOpenAPIClientsFedExAddressValidationParsedPostalCode}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'parsedPostalCode'?: CommercePlatformOpenAPIClientsFedExAddressValidationParsedPostalCode;
    /**
     * 
     * @type {CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'classification'?: CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'postOfficeBox'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'normalizedStatusNameDPV'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'standardizedStatusNameMatchSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'resolutionMethodName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'ruralRouteHighwayContract'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'generalDelivery'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddress
     */
    'attributes'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification = {
    Mixed: 'MIXED',
    Unknown: 'UNKNOWN',
    Business: 'BUSINESS',
    Residential: 'RESIDENTIAL'
} as const;

export type CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification = typeof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification[keyof typeof CommercePlatformOpenAPIClientsFedExAddressValidationResolvedAddressClassification];


/**
 * 
 * @export
 * @enum {string}
 */

export const GPAWebDataTypesIndustryType = {
    Education: 'Education',
    Financial: 'Financial',
    Healthcare: 'Healthcare',
    Hospitality: 'Hospitality',
    Retail: 'Retail',
    Consumer: 'Consumer',
    GeneralInternalMedicine: 'General_Internal_Medicine',
    HomeHealthCareServices: 'Home_Health_Care_Services',
    Hospital: 'Hospital',
    LongTermCareFacility: 'Long_Term_Care_Facility',
    MedicalDiagnosticLaboratory: 'Medical_Diagnostic_Laboratory',
    MentalHealthPractitioner: 'Mental_Health_Practitioner',
    PhysicalOccupationalTherapy: 'Physical_Occupational_Therapy',
    Specialist: 'Specialist',
    UrgentCareCenterClinic: 'Urgent_Care_Center_Clinic',
    ConsumerServices: 'Consumer_Services',
    Advertising: 'Advertising',
    AerospaceDefense: 'Aerospace_Defense',
    Agriculture: 'Agriculture',
    AirlinesAviation: 'Airlines_Aviation',
    AlternativeMedicine: 'Alternative_Medicine',
    Apparel: 'Apparel',
    Automotive: 'Automotive',
    Banking: 'Banking',
    Biotechnology: 'Biotechnology',
    BusinessServices: 'Business_Services',
    CasinoGambling: 'Casino_Gambling',
    Chemicals: 'Chemicals',
    ClubsOrganizations: 'Clubs_Organizations',
    Communications: 'Communications',
    ComputerSoftware: 'Computer_Software',
    Construction: 'Construction',
    Consulting: 'Consulting',
    Design: 'Design',
    Electronics: 'Electronics',
    Energy: 'Energy',
    Engineering: 'Engineering',
    Entertainment: 'Entertainment',
    Environmental: 'Environmental',
    EventServices: 'Event_Services',
    FacilitiesServices: 'Facilities_Services',
    FoodBeverage: 'Food_Beverage',
    Furniture: 'Furniture',
    Government: 'Government',
    InformationTechnology: 'Information_Technology',
    Insurance: 'Insurance',
    Legal: 'Legal',
    LogisticsSupplyChain: 'Logistics_Supply_Chain',
    Machinery: 'Machinery',
    Manufacturing: 'Manufacturing',
    Media: 'Media',
    MotionPictures: 'Motion_Pictures',
    Museums: 'Museums',
    NotForProfit: 'Not_For_Profit',
    Printing: 'Printing',
    Professional: 'Professional',
    RealEstate: 'Real_Estate',
    Recreation: 'Recreation',
    ReligiousOrganizations: 'Religious_Organizations',
    Services: 'Services',
    Technology: 'Technology',
    Telecommunications: 'Telecommunications',
    TobaccoSmokeshop: 'Tobacco_Smokeshop',
    Transportation: 'Transportation',
    Utilities: 'Utilities',
    Wholesale: 'Wholesale',
    Other: 'Other'
} as const;

export type GPAWebDataTypesIndustryType = typeof GPAWebDataTypesIndustryType[keyof typeof GPAWebDataTypesIndustryType];


/**
 * 
 * @export
 * @enum {string}
 */

export const GPAWebDataTypesPaymentOptionType = {
    Unknown: 'Unknown',
    Visa: 'Visa',
    MasterCard: 'MasterCard',
    AmericanExpress: 'AmericanExpress',
    Discover: 'Discover',
    Net30: 'Net30'
} as const;

export type GPAWebDataTypesPaymentOptionType = typeof GPAWebDataTypesPaymentOptionType[keyof typeof GPAWebDataTypesPaymentOptionType];


/**
 * 
 * @export
 * @enum {string}
 */

export const GPAWebDataTypesResourceType = {
    DesignerService: 'DesignerService',
    Warranty: 'Warranty'
} as const;

export type GPAWebDataTypesResourceType = typeof GPAWebDataTypesResourceType[keyof typeof GPAWebDataTypesResourceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const GPAWebDataTypesResponsibilityCenter = {
    D2G: 'D2G',
    Up: 'UP',
    Tr: 'TR',
    Md: 'MD'
} as const;

export type GPAWebDataTypesResponsibilityCenter = typeof GPAWebDataTypesResponsibilityCenter[keyof typeof GPAWebDataTypesResponsibilityCenter];


/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreJsonPatchOperationsOperation
 */
export interface MicrosoftAspNetCoreJsonPatchOperationsOperation {
    /**
     * 
     * @type {any}
     * @memberof MicrosoftAspNetCoreJsonPatchOperationsOperation
     */
    'value'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreJsonPatchOperationsOperation
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreJsonPatchOperationsOperation
     */
    'op'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreJsonPatchOperationsOperation
     */
    'from'?: string | null;
}
/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreMvcModelBindingModelError
 */
export interface MicrosoftAspNetCoreMvcModelBindingModelError {
    /**
     * 
     * @type {any}
     * @memberof MicrosoftAspNetCoreMvcModelBindingModelError
     */
    'exception'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcModelBindingModelError
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreMvcModelBindingModelStateEntry
 */
export interface MicrosoftAspNetCoreMvcModelBindingModelStateEntry {
    /**
     * 
     * @type {any}
     * @memberof MicrosoftAspNetCoreMvcModelBindingModelStateEntry
     */
    'rawValue'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcModelBindingModelStateEntry
     */
    'attemptedValue'?: string | null;
    /**
     * 
     * @type {Array<MicrosoftAspNetCoreMvcModelBindingModelError>}
     * @memberof MicrosoftAspNetCoreMvcModelBindingModelStateEntry
     */
    'errors'?: Array<MicrosoftAspNetCoreMvcModelBindingModelError> | null;
    /**
     * 
     * @type {MicrosoftAspNetCoreMvcModelBindingModelValidationState}
     * @memberof MicrosoftAspNetCoreMvcModelBindingModelStateEntry
     */
    'validationState'?: MicrosoftAspNetCoreMvcModelBindingModelValidationState;
    /**
     * 
     * @type {boolean}
     * @memberof MicrosoftAspNetCoreMvcModelBindingModelStateEntry
     */
    'isContainerNode'?: boolean;
    /**
     * 
     * @type {Array<MicrosoftAspNetCoreMvcModelBindingModelStateEntry>}
     * @memberof MicrosoftAspNetCoreMvcModelBindingModelStateEntry
     */
    'children'?: Array<MicrosoftAspNetCoreMvcModelBindingModelStateEntry> | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const MicrosoftAspNetCoreMvcModelBindingModelValidationState = {
    Unvalidated: 'Unvalidated',
    Invalid: 'Invalid',
    Valid: 'Valid',
    Skipped: 'Skipped'
} as const;

export type MicrosoftAspNetCoreMvcModelBindingModelValidationState = typeof MicrosoftAspNetCoreMvcModelBindingModelValidationState[keyof typeof MicrosoftAspNetCoreMvcModelBindingModelValidationState];


/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreMvcProblemDetails
 */
export interface MicrosoftAspNetCoreMvcProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    'instance'?: string | null;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} hsId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest} [commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAuthenticateAsync: async (hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest?: CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountAuthenticateAsync', 'hsId', hsId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountAuthenticateAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/authenticate`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest} [commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreateAddressAsync: async (hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountCreateAddressAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountCreateAddressAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountCreateAddressAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/address`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest} [commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreateAsync: async (hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountCreateAsync', 'hsId', hsId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountCreateAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest} [commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreatePaymentAsync: async (hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest?: CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountCreatePaymentAsync', 'hsId', hsId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountCreatePaymentAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/payment`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest} [commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreateRecoveryAsync: async (hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountCreateRecoveryAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountCreateRecoveryAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountCreateRecoveryAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/recovery/create`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountDeleteAddressAsync: async (hsId: number, id: number, addressId: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountDeleteAddressAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountDeleteAddressAsync', 'id', id)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('accountDeleteAddressAsync', 'addressId', addressId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountDeleteAddressAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/address/{addressId}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} paymentId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountDeletePaymentAsync: async (hsId: number, id: number, paymentId: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountDeletePaymentAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountDeletePaymentAsync', 'id', id)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('accountDeletePaymentAsync', 'paymentId', paymentId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountDeletePaymentAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/payment/{paymentId}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAddressAsync: async (hsId: number, id: number, addressId: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetAddressAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetAddressAsync', 'id', id)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('accountGetAddressAsync', 'addressId', addressId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetAddressAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/address/{addressId}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reserved for service roles only for security reasons (to prevent account data leak to unauthorized users)
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAddressByIdAsync: async (addressId: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('accountGetAddressByIdAsync', 'addressId', addressId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetAddressByIdAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/address/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAddressesAsync: async (hsId: number, id: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetAddressesAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetAddressesAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetAddressesAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/addresses`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAllAsync: async (email: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('accountGetAllAsync', 'email', email)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetAllAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAsync: async (hsId: number, id: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} instructions 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAsync_1: async (hsId: number, instructions: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetAsync_1', 'hsId', hsId)
            // verify required parameter 'instructions' is not null or undefined
            assertParamExists('accountGetAsync_1', 'instructions', instructions)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetAsync_1', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{instructions}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"instructions"}}`, encodeURIComponent(String(instructions)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} instructions 
         * @param {string} authorization access token
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [excludeReadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetCartsAsync: async (hsId: number, instructions: string, authorization: string, page?: number, perPage?: number, excludeReadOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetCartsAsync', 'hsId', hsId)
            // verify required parameter 'instructions' is not null or undefined
            assertParamExists('accountGetCartsAsync', 'instructions', instructions)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetCartsAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/carts/{instructions}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"instructions"}}`, encodeURIComponent(String(instructions)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            if (excludeReadOnly !== undefined) {
                localVarQueryParameter['excludeReadOnly'] = excludeReadOnly;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [excludeReadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetCartsAsync_2: async (hsId: number, id: number, authorization: string, page?: number, perPage?: number, excludeReadOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetCartsAsync_2', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetCartsAsync_2', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetCartsAsync_2', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/carts`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            if (excludeReadOnly !== undefined) {
                localVarQueryParameter['excludeReadOnly'] = excludeReadOnly;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetMiniAsync: async (hsId: number, id: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetMiniAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetMiniAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetMiniAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/mini`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} orderNumber 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetOrderAsync: async (hsId: number, id: number, orderNumber: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetOrderAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetOrderAsync', 'id', id)
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('accountGetOrderAsync', 'orderNumber', orderNumber)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetOrderAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/order/{orderNumber}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} instructions 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetOrdersAsync: async (hsId: number, id: number, instructions: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetOrdersAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetOrdersAsync', 'id', id)
            // verify required parameter 'instructions' is not null or undefined
            assertParamExists('accountGetOrdersAsync', 'instructions', instructions)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetOrdersAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/orders/{instructions}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"instructions"}}`, encodeURIComponent(String(instructions)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} paymentId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetPaymentAsync: async (hsId: number, id: number, paymentId: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetPaymentAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetPaymentAsync', 'id', id)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('accountGetPaymentAsync', 'paymentId', paymentId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetPaymentAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/payment/{paymentId}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cannot be exposed to non Admin/Service users for security
         * @param {number} hsId 
         * @param {number} paymentId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetPaymentByIdAsync: async (hsId: number, paymentId: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetPaymentByIdAsync', 'hsId', hsId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('accountGetPaymentByIdAsync', 'paymentId', paymentId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetPaymentByIdAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/payment/{paymentId}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetPaymentsAsync: async (hsId: number, id: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetPaymentsAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetPaymentsAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetPaymentsAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/payments`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} recoveryId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetRecoveryAsync: async (hsId: number, id: number, recoveryId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetRecoveryAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetRecoveryAsync', 'id', id)
            // verify required parameter 'recoveryId' is not null or undefined
            assertParamExists('accountGetRecoveryAsync', 'recoveryId', recoveryId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetRecoveryAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/recovery/{recoveryId}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"recoveryId"}}`, encodeURIComponent(String(recoveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetRecoveryEligibleAsync: async (hsId: number, id: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountGetRecoveryEligibleAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountGetRecoveryEligibleAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountGetRecoveryEligibleAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/recovery/eligible`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} token 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountRecoveryVerifyAsync: async (hsId: number, id: number, token: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountRecoveryVerifyAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountRecoveryVerifyAsync', 'id', id)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('accountRecoveryVerifyAsync', 'token', token)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountRecoveryVerifyAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/recovery/verify/{token}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} recoveryId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest} [commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountResetPasswordAsync: async (hsId: number, id: number, recoveryId: string, authorization: string, commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest?: CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountResetPasswordAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountResetPasswordAsync', 'id', id)
            // verify required parameter 'recoveryId' is not null or undefined
            assertParamExists('accountResetPasswordAsync', 'recoveryId', recoveryId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountResetPasswordAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/recovery/{recoveryId}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"recoveryId"}}`, encodeURIComponent(String(recoveryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdateAddressAsync: async (hsId: number, id: number, addressId: number, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountUpdateAddressAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountUpdateAddressAsync', 'id', id)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('accountUpdateAddressAsync', 'addressId', addressId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountUpdateAddressAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/address/{addressId}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(microsoftAspNetCoreJsonPatchOperationsOperation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdateAsync: async (hsId: number, id: number, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountUpdateAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountUpdateAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountUpdateAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(microsoftAspNetCoreJsonPatchOperationsOperation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest} [commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdatePasswordAsync: async (hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest?: CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountUpdatePasswordAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountUpdatePasswordAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountUpdatePasswordAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/password`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountVerifyAsync: async (hsId: number, id: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountVerifyAsync', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountVerifyAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountVerifyAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/verify`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} token 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountVerifyAsync_3: async (hsId: number, id: number, token: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('accountVerifyAsync_3', 'hsId', hsId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountVerifyAsync_3', 'id', id)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('accountVerifyAsync_3', 'token', token)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('accountVerifyAsync_3', 'authorization', authorization)
            const localVarPath = `/api/v1/account/{hsId}/{id}/verify/{token}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} hsId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest} [commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAuthenticateAsync(hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest?: CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAuthenticateAsync(hsId, authorization, commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest} [commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountCreateAddressAsync(hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountCreateAddressAsync(hsId, id, authorization, commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest} [commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountCreateAsync(hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesAccountCreateAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountCreateAsync(hsId, authorization, commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest} [commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountCreatePaymentAsync(hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest?: CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountCreatePaymentAsync(hsId, authorization, commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest} [commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountCreateRecoveryAsync(hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesAccountCreateRecoveryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountCreateRecoveryAsync(hsId, id, authorization, commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountDeleteAddressAsync(hsId: number, id: number, addressId: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountDeleteAddressAsync(hsId, id, addressId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} paymentId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountDeletePaymentAsync(hsId: number, id: number, paymentId: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountDeletePaymentAsync(hsId, id, paymentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetAddressAsync(hsId: number, id: number, addressId: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetAddressAsync(hsId, id, addressId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reserved for service roles only for security reasons (to prevent account data leak to unauthorized users)
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetAddressByIdAsync(addressId: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetAddressByIdAsync(addressId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetAddressesAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetAddressesAsync(hsId, id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetAllAsync(email: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicAccountDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetAllAsync(email, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetAsync(hsId, id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} instructions 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetAsync_1(hsId: number, instructions: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetAsync_1(hsId, instructions, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} instructions 
         * @param {string} authorization access token
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [excludeReadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetCartsAsync(hsId: number, instructions: string, authorization: string, page?: number, perPage?: number, excludeReadOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetCartsAsync(hsId, instructions, authorization, page, perPage, excludeReadOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [excludeReadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetCartsAsync_2(hsId: number, id: number, authorization: string, page?: number, perPage?: number, excludeReadOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetCartsAsync_2(hsId, id, authorization, page, perPage, excludeReadOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetMiniAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetMiniAsync(hsId, id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} orderNumber 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetOrderAsync(hsId: number, id: number, orderNumber: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicOrderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetOrderAsync(hsId, id, orderNumber, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} instructions 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetOrdersAsync(hsId: number, id: number, instructions: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicOrderDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetOrdersAsync(hsId, id, instructions, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} paymentId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetPaymentAsync(hsId: number, id: number, paymentId: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetPaymentAsync(hsId, id, paymentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cannot be exposed to non Admin/Service users for security
         * @param {number} hsId 
         * @param {number} paymentId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetPaymentByIdAsync(hsId: number, paymentId: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetPaymentByIdAsync(hsId, paymentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetPaymentsAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetPaymentsAsync(hsId, id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} recoveryId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetRecoveryAsync(hsId: number, id: number, recoveryId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetRecoveryAsync(hsId, id, recoveryId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetRecoveryEligibleAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetRecoveryEligibleAsync(hsId, id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} token 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountRecoveryVerifyAsync(hsId: number, id: number, token: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountRecoveryVerifyAsync(hsId, id, token, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} recoveryId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest} [commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountResetPasswordAsync(hsId: number, id: number, recoveryId: string, authorization: string, commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest?: CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountResetPasswordAsync(hsId, id, recoveryId, authorization, commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountUpdateAddressAsync(hsId: number, id: number, addressId: number, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUpdateAddressAsync(hsId, id, addressId, authorization, microsoftAspNetCoreJsonPatchOperationsOperation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountUpdateAsync(hsId: number, id: number, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUpdateAsync(hsId, id, authorization, microsoftAspNetCoreJsonPatchOperationsOperation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest} [commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountUpdatePasswordAsync(hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest?: CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUpdatePasswordAsync(hsId, id, authorization, commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountVerifyAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountVerifyAsync(hsId, id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} token 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountVerifyAsync_3(hsId: number, id: number, token: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountVerifyAsync_3(hsId, id, token, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @param {number} hsId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest} [commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAuthenticateAsync(hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest?: CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO> {
            return localVarFp.accountAuthenticateAsync(hsId, authorization, commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest} [commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreateAddressAsync(hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO> {
            return localVarFp.accountCreateAddressAsync(hsId, id, authorization, commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest} [commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreateAsync(hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesAccountCreateAccountResponse> {
            return localVarFp.accountCreateAsync(hsId, authorization, commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest} [commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreatePaymentAsync(hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest?: CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO> {
            return localVarFp.accountCreatePaymentAsync(hsId, authorization, commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest} [commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreateRecoveryAsync(hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesAccountCreateRecoveryResponse> {
            return localVarFp.accountCreateRecoveryAsync(hsId, id, authorization, commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountDeleteAddressAsync(hsId: number, id: number, addressId: number, authorization: string, options?: any): AxiosPromise<void> {
            return localVarFp.accountDeleteAddressAsync(hsId, id, addressId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} paymentId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountDeletePaymentAsync(hsId: number, id: number, paymentId: number, authorization: string, options?: any): AxiosPromise<void> {
            return localVarFp.accountDeletePaymentAsync(hsId, id, paymentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAddressAsync(hsId: number, id: number, addressId: number, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO> {
            return localVarFp.accountGetAddressAsync(hsId, id, addressId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reserved for service roles only for security reasons (to prevent account data leak to unauthorized users)
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAddressByIdAsync(addressId: number, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO> {
            return localVarFp.accountGetAddressByIdAsync(addressId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAddressesAsync(hsId: number, id: number, authorization: string, options?: any): AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO>> {
            return localVarFp.accountGetAddressesAsync(hsId, id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAllAsync(email: string, authorization: string, options?: any): AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicAccountDTO>> {
            return localVarFp.accountGetAllAsync(email, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAsync(hsId: number, id: number, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountDTO> {
            return localVarFp.accountGetAsync(hsId, id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} instructions 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetAsync_1(hsId: number, instructions: string, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountDTO> {
            return localVarFp.accountGetAsync_1(hsId, instructions, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} instructions 
         * @param {string} authorization access token
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [excludeReadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetCartsAsync(hsId: number, instructions: string, authorization: string, page?: number, perPage?: number, excludeReadOnly?: boolean, options?: any): AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO>> {
            return localVarFp.accountGetCartsAsync(hsId, instructions, authorization, page, perPage, excludeReadOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [excludeReadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetCartsAsync_2(hsId: number, id: number, authorization: string, page?: number, perPage?: number, excludeReadOnly?: boolean, options?: any): AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO>> {
            return localVarFp.accountGetCartsAsync_2(hsId, id, authorization, page, perPage, excludeReadOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetMiniAsync(hsId: number, id: number, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO> {
            return localVarFp.accountGetMiniAsync(hsId, id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} orderNumber 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetOrderAsync(hsId: number, id: number, orderNumber: string, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicOrderDTO> {
            return localVarFp.accountGetOrderAsync(hsId, id, orderNumber, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} instructions 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetOrdersAsync(hsId: number, id: number, instructions: string, authorization: string, options?: any): AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicOrderDTO>> {
            return localVarFp.accountGetOrdersAsync(hsId, id, instructions, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} paymentId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetPaymentAsync(hsId: number, id: number, paymentId: number, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsAuthenticatedPaymentMiniDTO> {
            return localVarFp.accountGetPaymentAsync(hsId, id, paymentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cannot be exposed to non Admin/Service users for security
         * @param {number} hsId 
         * @param {number} paymentId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetPaymentByIdAsync(hsId: number, paymentId: number, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO> {
            return localVarFp.accountGetPaymentByIdAsync(hsId, paymentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetPaymentsAsync(hsId: number, id: number, authorization: string, options?: any): AxiosPromise<Array<CommercePlatformCartServiceModelsDTOsPublicPaymentMiniDTO>> {
            return localVarFp.accountGetPaymentsAsync(hsId, id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} recoveryId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetRecoveryAsync(hsId: number, id: number, recoveryId: string, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO> {
            return localVarFp.accountGetRecoveryAsync(hsId, id, recoveryId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetRecoveryEligibleAsync(hsId: number, id: number, authorization: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.accountGetRecoveryEligibleAsync(hsId, id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} token 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountRecoveryVerifyAsync(hsId: number, id: number, token: string, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsAuthenticatedAccountRecoveryMiniDTO> {
            return localVarFp.accountRecoveryVerifyAsync(hsId, id, token, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} recoveryId 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest} [commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountResetPasswordAsync(hsId: number, id: number, recoveryId: string, authorization: string, commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest?: CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO> {
            return localVarFp.accountResetPasswordAsync(hsId, id, recoveryId, authorization, commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {number} addressId 
         * @param {string} authorization access token
         * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdateAddressAsync(hsId: number, id: number, addressId: number, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO> {
            return localVarFp.accountUpdateAddressAsync(hsId, id, addressId, authorization, microsoftAspNetCoreJsonPatchOperationsOperation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdateAsync(hsId: number, id: number, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO> {
            return localVarFp.accountUpdateAsync(hsId, id, authorization, microsoftAspNetCoreJsonPatchOperationsOperation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest} [commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdatePasswordAsync(hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest?: CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountMiniDTO> {
            return localVarFp.accountUpdatePasswordAsync(hsId, id, authorization, commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountVerifyAsync(hsId: number, id: number, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountDTO> {
            return localVarFp.accountVerifyAsync(hsId, id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {number} id 
         * @param {string} token 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountVerifyAsync_3(hsId: number, id: number, token: string, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicAccountDTO> {
            return localVarFp.accountVerifyAsync_3(hsId, id, token, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @param {number} hsId 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest} [commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountAuthenticateAsync(hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest?: CommercePlatformCartServiceModelsRequestsAccountAuthenticateRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountAuthenticateAsync(hsId, authorization, commercePlatformCartServiceModelsRequestsAccountAuthenticateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest} [commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountCreateAddressAsync(hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateAddressRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountCreateAddressAsync(hsId, id, authorization, commercePlatformCartServiceModelsRequestsAccountCreateAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest} [commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountCreateAsync(hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateAccountRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountCreateAsync(hsId, authorization, commercePlatformCartServiceModelsRequestsAccountCreateAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest} [commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountCreatePaymentAsync(hsId: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest?: CommercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountCreatePaymentAsync(hsId, authorization, commercePlatformCartServiceModelsRequestsAccountCreatePaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest} [commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountCreateRecoveryAsync(hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest?: CommercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountCreateRecoveryAsync(hsId, id, authorization, commercePlatformCartServiceModelsRequestsAccountCreateRecoveryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {number} addressId 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountDeleteAddressAsync(hsId: number, id: number, addressId: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountDeleteAddressAsync(hsId, id, addressId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {number} paymentId 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountDeletePaymentAsync(hsId: number, id: number, paymentId: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountDeletePaymentAsync(hsId, id, paymentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {number} addressId 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetAddressAsync(hsId: number, id: number, addressId: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetAddressAsync(hsId, id, addressId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reserved for service roles only for security reasons (to prevent account data leak to unauthorized users)
     * @param {number} addressId 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetAddressByIdAsync(addressId: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetAddressByIdAsync(addressId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetAddressesAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetAddressesAsync(hsId, id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetAllAsync(email: string, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetAllAsync(email, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetAsync(hsId, id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {string} instructions 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetAsync_1(hsId: number, instructions: string, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetAsync_1(hsId, instructions, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {string} instructions 
     * @param {string} authorization access token
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {boolean} [excludeReadOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetCartsAsync(hsId: number, instructions: string, authorization: string, page?: number, perPage?: number, excludeReadOnly?: boolean, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetCartsAsync(hsId, instructions, authorization, page, perPage, excludeReadOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {boolean} [excludeReadOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetCartsAsync_2(hsId: number, id: number, authorization: string, page?: number, perPage?: number, excludeReadOnly?: boolean, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetCartsAsync_2(hsId, id, authorization, page, perPage, excludeReadOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetMiniAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetMiniAsync(hsId, id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} orderNumber 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetOrderAsync(hsId: number, id: number, orderNumber: string, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetOrderAsync(hsId, id, orderNumber, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} instructions 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetOrdersAsync(hsId: number, id: number, instructions: string, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetOrdersAsync(hsId, id, instructions, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {number} paymentId 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetPaymentAsync(hsId: number, id: number, paymentId: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetPaymentAsync(hsId, id, paymentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cannot be exposed to non Admin/Service users for security
     * @param {number} hsId 
     * @param {number} paymentId 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetPaymentByIdAsync(hsId: number, paymentId: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetPaymentByIdAsync(hsId, paymentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetPaymentsAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetPaymentsAsync(hsId, id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} recoveryId 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetRecoveryAsync(hsId: number, id: number, recoveryId: string, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetRecoveryAsync(hsId, id, recoveryId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetRecoveryEligibleAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountGetRecoveryEligibleAsync(hsId, id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} token 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountRecoveryVerifyAsync(hsId: number, id: number, token: string, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountRecoveryVerifyAsync(hsId, id, token, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} recoveryId 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest} [commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountResetPasswordAsync(hsId: number, id: number, recoveryId: string, authorization: string, commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest?: CommercePlatformCartServiceModelsRequestsAccountResetPasswordRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountResetPasswordAsync(hsId, id, recoveryId, authorization, commercePlatformCartServiceModelsRequestsAccountResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {number} addressId 
     * @param {string} authorization access token
     * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountUpdateAddressAsync(hsId: number, id: number, addressId: number, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountUpdateAddressAsync(hsId, id, addressId, authorization, microsoftAspNetCoreJsonPatchOperationsOperation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountUpdateAsync(hsId: number, id: number, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountUpdateAsync(hsId, id, authorization, microsoftAspNetCoreJsonPatchOperationsOperation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest} [commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountUpdatePasswordAsync(hsId: number, id: number, authorization: string, commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest?: CommercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountUpdatePasswordAsync(hsId, id, authorization, commercePlatformCartServiceModelsRequestsAccountUpdatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountVerifyAsync(hsId: number, id: number, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountVerifyAsync(hsId, id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {number} id 
     * @param {string} token 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountVerifyAsync_3(hsId: number, id: number, token: string, authorization: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountVerifyAsync_3(hsId, id, token, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CartApi - axios parameter creator
 * @export
 */
export const CartApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsCartAddItemRequest} [commercePlatformCartServiceModelsRequestsCartAddItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartAddItemAsync: async (id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemRequest?: CommercePlatformCartServiceModelsRequestsCartAddItemRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartAddItemAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartAddItemAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}/item`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsCartAddItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest>} [commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartAddItemResourcesAsync: async (id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest?: Array<CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartAddItemResourcesAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartAddItemResourcesAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}/items/resources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<CommercePlatformCartServiceModelsRequestsCartAddItemRequest>} [commercePlatformCartServiceModelsRequestsCartAddItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartAddItemsAsync: async (id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemRequest?: Array<CommercePlatformCartServiceModelsRequestsCartAddItemRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartAddItemsAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartAddItemsAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}/items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsCartAddItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsCartCreateRequest} [commercePlatformCartServiceModelsRequestsCartCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartCreateAsync: async (authorization: string, commercePlatformCartServiceModelsRequestsCartCreateRequest?: CommercePlatformCartServiceModelsRequestsCartCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartCreateAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsCartCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} itemId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartDeleteItemAsync: async (id: string, itemId: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartDeleteItemAsync', 'id', id)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('cartDeleteItemAsync', 'itemId', itemId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartDeleteItemAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}/item/{itemId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Purposely restricted from user access
         * @param {string} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartExistsAsync: async (id: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartExistsAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartExistsAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}/exists`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the corresponding CartDTO for the given cart id directly from the database w/o any recalculation.
         * @param {string} id Corresponding cart id
         * @param {string} authorization access token
         * @param {boolean} [omitAddresses] Determines whether or not to map the billing/shipping addresses within the resulting object.
         * @param {boolean} [omitGroups] Determines whether or not to map the line item groups within the resulting object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetAsync: async (id: string, authorization: string, omitAddresses?: boolean, omitGroups?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartGetAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartGetAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (omitAddresses !== undefined) {
                localVarQueryParameter['omitAddresses'] = omitAddresses;
            }

            if (omitGroups !== undefined) {
                localVarQueryParameter['omitGroups'] = omitGroups;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {number} [productId] 
         * @param {number} [artworkId] 
         * @param {number} [width] 
         * @param {number} [height] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetItemByAttributesAsync: async (id: string, authorization: string, productId?: number, artworkId?: number, width?: number, height?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartGetItemByAttributesAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartGetItemByAttributesAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}/item`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (artworkId !== undefined) {
                localVarQueryParameter['artworkId'] = artworkId;
            }

            if (width !== undefined) {
                localVarQueryParameter['width'] = width;
            }

            if (height !== undefined) {
                localVarQueryParameter['height'] = height;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} itemId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetItemByIdAsync: async (id: string, itemId: number, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartGetItemByIdAsync', 'id', id)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('cartGetItemByIdAsync', 'itemId', itemId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartGetItemByIdAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}/item/{itemId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetItemCountAsync: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartGetItemCountAsync', 'id', id)
            const localVarPath = `/api/v1/cart/{id}/item/count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetShippingOptionsAsync: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartGetShippingOptionsAsync', 'id', id)
            const localVarPath = `/api/v1/cart/{id}/shipping/options`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartRecalculateAsync: async (id: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartRecalculateAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartRecalculateAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}/recalculate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartUpdateAsync: async (id: string, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartUpdateAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartUpdateAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(microsoftAspNetCoreJsonPatchOperationsOperation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The order of the requests will drive how the updates are performed, be sure to take that into account when sending more than one request.  <remarks>When a change results in an item collision, then the item being modified will be the victim.</remarks>
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest>} [commercePlatformCartServiceModelsRequestsCartUpdateItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartUpdateItemsAsync: async (id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartUpdateItemRequest?: Array<CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cartUpdateItemsAsync', 'id', id)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cartUpdateItemsAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/cart/{id}/items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsCartUpdateItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CartApi - functional programming interface
 * @export
 */
export const CartApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CartApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsCartAddItemRequest} [commercePlatformCartServiceModelsRequestsCartAddItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartAddItemAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemRequest?: CommercePlatformCartServiceModelsRequestsCartAddItemRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartAddItemAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartAddItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest>} [commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartAddItemResourcesAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest?: Array<CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartAddItemResourcesAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<CommercePlatformCartServiceModelsRequestsCartAddItemRequest>} [commercePlatformCartServiceModelsRequestsCartAddItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartAddItemsAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemRequest?: Array<CommercePlatformCartServiceModelsRequestsCartAddItemRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartAddItemsAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartAddItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsCartCreateRequest} [commercePlatformCartServiceModelsRequestsCartCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartCreateAsync(authorization: string, commercePlatformCartServiceModelsRequestsCartCreateRequest?: CommercePlatformCartServiceModelsRequestsCartCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartCreateAsync(authorization, commercePlatformCartServiceModelsRequestsCartCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} itemId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartDeleteItemAsync(id: string, itemId: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartDeleteItemAsync(id, itemId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Purposely restricted from user access
         * @param {string} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartExistsAsync(id: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartExistsAsync(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the corresponding CartDTO for the given cart id directly from the database w/o any recalculation.
         * @param {string} id Corresponding cart id
         * @param {string} authorization access token
         * @param {boolean} [omitAddresses] Determines whether or not to map the billing/shipping addresses within the resulting object.
         * @param {boolean} [omitGroups] Determines whether or not to map the line item groups within the resulting object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartGetAsync(id: string, authorization: string, omitAddresses?: boolean, omitGroups?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicCartDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartGetAsync(id, authorization, omitAddresses, omitGroups, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {number} [productId] 
         * @param {number} [artworkId] 
         * @param {number} [width] 
         * @param {number} [height] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartGetItemByAttributesAsync(id: string, authorization: string, productId?: number, artworkId?: number, width?: number, height?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicCartItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartGetItemByAttributesAsync(id, authorization, productId, artworkId, width, height, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} itemId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartGetItemByIdAsync(id: string, itemId: number, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicCartItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartGetItemByIdAsync(id, itemId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartGetItemCountAsync(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartGetItemCountAsync(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartGetShippingOptionsAsync(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartGetShippingOptionsAsync(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartRecalculateAsync(id: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartRecalculateAsync(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartUpdateAsync(id: string, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartUpdateAsync(id, authorization, microsoftAspNetCoreJsonPatchOperationsOperation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary The order of the requests will drive how the updates are performed, be sure to take that into account when sending more than one request.  <remarks>When a change results in an item collision, then the item being modified will be the victim.</remarks>
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest>} [commercePlatformCartServiceModelsRequestsCartUpdateItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cartUpdateItemsAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartUpdateItemRequest?: Array<CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cartUpdateItemsAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartUpdateItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CartApi - factory interface
 * @export
 */
export const CartApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CartApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsCartAddItemRequest} [commercePlatformCartServiceModelsRequestsCartAddItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartAddItemAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemRequest?: CommercePlatformCartServiceModelsRequestsCartAddItemRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse> {
            return localVarFp.cartAddItemAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartAddItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest>} [commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartAddItemResourcesAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest?: Array<CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest>, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse> {
            return localVarFp.cartAddItemResourcesAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<CommercePlatformCartServiceModelsRequestsCartAddItemRequest>} [commercePlatformCartServiceModelsRequestsCartAddItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartAddItemsAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemRequest?: Array<CommercePlatformCartServiceModelsRequestsCartAddItemRequest>, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse> {
            return localVarFp.cartAddItemsAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartAddItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsCartCreateRequest} [commercePlatformCartServiceModelsRequestsCartCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartCreateAsync(authorization: string, commercePlatformCartServiceModelsRequestsCartCreateRequest?: CommercePlatformCartServiceModelsRequestsCartCreateRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicCartMiniDTO> {
            return localVarFp.cartCreateAsync(authorization, commercePlatformCartServiceModelsRequestsCartCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} itemId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartDeleteItemAsync(id: string, itemId: number, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse> {
            return localVarFp.cartDeleteItemAsync(id, itemId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Purposely restricted from user access
         * @param {string} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartExistsAsync(id: string, authorization: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.cartExistsAsync(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the corresponding CartDTO for the given cart id directly from the database w/o any recalculation.
         * @param {string} id Corresponding cart id
         * @param {string} authorization access token
         * @param {boolean} [omitAddresses] Determines whether or not to map the billing/shipping addresses within the resulting object.
         * @param {boolean} [omitGroups] Determines whether or not to map the line item groups within the resulting object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetAsync(id: string, authorization: string, omitAddresses?: boolean, omitGroups?: boolean, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicCartDTO> {
            return localVarFp.cartGetAsync(id, authorization, omitAddresses, omitGroups, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {number} [productId] 
         * @param {number} [artworkId] 
         * @param {number} [width] 
         * @param {number} [height] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetItemByAttributesAsync(id: string, authorization: string, productId?: number, artworkId?: number, width?: number, height?: number, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicCartItemDTO> {
            return localVarFp.cartGetItemByAttributesAsync(id, authorization, productId, artworkId, width, height, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} itemId 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetItemByIdAsync(id: string, itemId: number, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicCartItemDTO> {
            return localVarFp.cartGetItemByIdAsync(id, itemId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetItemCountAsync(id: string, options?: any): AxiosPromise<number> {
            return localVarFp.cartGetItemCountAsync(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartGetShippingOptionsAsync(id: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesCartShippingOptionsResponse> {
            return localVarFp.cartGetShippingOptionsAsync(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartRecalculateAsync(id: string, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse> {
            return localVarFp.cartRecalculateAsync(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartUpdateAsync(id: string, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse> {
            return localVarFp.cartUpdateAsync(id, authorization, microsoftAspNetCoreJsonPatchOperationsOperation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The order of the requests will drive how the updates are performed, be sure to take that into account when sending more than one request.  <remarks>When a change results in an item collision, then the item being modified will be the victim.</remarks>
         * @param {string} id 
         * @param {string} authorization access token
         * @param {Array<CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest>} [commercePlatformCartServiceModelsRequestsCartUpdateItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartUpdateItemsAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartUpdateItemRequest?: Array<CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest>, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesCartCartResponse> {
            return localVarFp.cartUpdateItemsAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartUpdateItemRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CartApi - object-oriented interface
 * @export
 * @class CartApi
 * @extends {BaseAPI}
 */
export class CartApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsCartAddItemRequest} [commercePlatformCartServiceModelsRequestsCartAddItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartAddItemAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemRequest?: CommercePlatformCartServiceModelsRequestsCartAddItemRequest, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartAddItemAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartAddItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} authorization access token
     * @param {Array<CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest>} [commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartAddItemResourcesAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest?: Array<CommercePlatformCartServiceModelsRequestsCartAddItemResourceRequest>, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartAddItemResourcesAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartAddItemResourceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} authorization access token
     * @param {Array<CommercePlatformCartServiceModelsRequestsCartAddItemRequest>} [commercePlatformCartServiceModelsRequestsCartAddItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartAddItemsAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartAddItemRequest?: Array<CommercePlatformCartServiceModelsRequestsCartAddItemRequest>, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartAddItemsAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartAddItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsCartCreateRequest} [commercePlatformCartServiceModelsRequestsCartCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartCreateAsync(authorization: string, commercePlatformCartServiceModelsRequestsCartCreateRequest?: CommercePlatformCartServiceModelsRequestsCartCreateRequest, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartCreateAsync(authorization, commercePlatformCartServiceModelsRequestsCartCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} itemId 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartDeleteItemAsync(id: string, itemId: number, authorization: string, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartDeleteItemAsync(id, itemId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Purposely restricted from user access
     * @param {string} id 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartExistsAsync(id: string, authorization: string, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartExistsAsync(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the corresponding CartDTO for the given cart id directly from the database w/o any recalculation.
     * @param {string} id Corresponding cart id
     * @param {string} authorization access token
     * @param {boolean} [omitAddresses] Determines whether or not to map the billing/shipping addresses within the resulting object.
     * @param {boolean} [omitGroups] Determines whether or not to map the line item groups within the resulting object.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartGetAsync(id: string, authorization: string, omitAddresses?: boolean, omitGroups?: boolean, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartGetAsync(id, authorization, omitAddresses, omitGroups, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} authorization access token
     * @param {number} [productId] 
     * @param {number} [artworkId] 
     * @param {number} [width] 
     * @param {number} [height] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartGetItemByAttributesAsync(id: string, authorization: string, productId?: number, artworkId?: number, width?: number, height?: number, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartGetItemByAttributesAsync(id, authorization, productId, artworkId, width, height, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} itemId 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartGetItemByIdAsync(id: string, itemId: number, authorization: string, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartGetItemByIdAsync(id, itemId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartGetItemCountAsync(id: string, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartGetItemCountAsync(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartGetShippingOptionsAsync(id: string, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartGetShippingOptionsAsync(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartRecalculateAsync(id: string, authorization: string, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartRecalculateAsync(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} authorization access token
     * @param {Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>} [microsoftAspNetCoreJsonPatchOperationsOperation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartUpdateAsync(id: string, authorization: string, microsoftAspNetCoreJsonPatchOperationsOperation?: Array<MicrosoftAspNetCoreJsonPatchOperationsOperation>, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartUpdateAsync(id, authorization, microsoftAspNetCoreJsonPatchOperationsOperation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The order of the requests will drive how the updates are performed, be sure to take that into account when sending more than one request.  <remarks>When a change results in an item collision, then the item being modified will be the victim.</remarks>
     * @param {string} id 
     * @param {string} authorization access token
     * @param {Array<CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest>} [commercePlatformCartServiceModelsRequestsCartUpdateItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    public cartUpdateItemsAsync(id: string, authorization: string, commercePlatformCartServiceModelsRequestsCartUpdateItemRequest?: Array<CommercePlatformCartServiceModelsRequestsCartUpdateItemRequest>, options?: AxiosRequestConfig) {
        return CartApiFp(this.configuration).cartUpdateItemsAsync(id, authorization, commercePlatformCartServiceModelsRequestsCartUpdateItemRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest} [commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreateAsync: async (authorization: string, commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest?: CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('orderCreateAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} orderNumber 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetAsync: async (hsId: number, orderNumber: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hsId' is not null or undefined
            assertParamExists('orderGetAsync', 'hsId', hsId)
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('orderGetAsync', 'orderNumber', orderNumber)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('orderGetAsync', 'authorization', authorization)
            const localVarPath = `/api/v1/order/{hsId}/{orderNumber}`
                .replace(`{${"hsId"}}`, encodeURIComponent(String(hsId)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest} [commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderCreateAsync(authorization: string, commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest?: CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicOrderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderCreateAsync(authorization, commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} orderNumber 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderGetAsync(hsId: number, orderNumber: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicOrderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderGetAsync(hsId, orderNumber, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization access token
         * @param {CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest} [commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreateAsync(authorization: string, commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest?: CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicOrderDTO> {
            return localVarFp.orderCreateAsync(authorization, commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} hsId 
         * @param {string} orderNumber 
         * @param {string} authorization access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetAsync(hsId: number, orderNumber: string, authorization: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicOrderDTO> {
            return localVarFp.orderGetAsync(hsId, orderNumber, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization access token
     * @param {CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest} [commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderCreateAsync(authorization: string, commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest?: CommercePlatformCartServiceModelsRequestsOrderCreateOrderRequest, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderCreateAsync(authorization, commercePlatformCartServiceModelsRequestsOrderCreateOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} hsId 
     * @param {string} orderNumber 
     * @param {string} authorization access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderGetAsync(hsId: number, orderNumber: string, authorization: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderGetAsync(hsId, orderNumber, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PingApi - axios parameter creator
 * @export
 */
export const PingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingIndexAsync: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingApi - functional programming interface
 * @export
 */
export const PingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pingIndexAsync(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceControllersSharedResponsesPingCodebaseInformationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pingIndexAsync(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PingApi - factory interface
 * @export
 */
export const PingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingIndexAsync(options?: any): AxiosPromise<CommercePlatformCartServiceControllersSharedResponsesPingCodebaseInformationResponse> {
            return localVarFp.pingIndexAsync(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingApi - object-oriented interface
 * @export
 * @class PingApi
 * @extends {BaseAPI}
 */
export class PingApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingApi
     */
    public pingIndexAsync(options?: AxiosRequestConfig) {
        return PingApiFp(this.configuration).pingIndexAsync(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShippingApi - axios parameter creator
 * @export
 */
export const ShippingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO} [commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippingGetAddressValidationAsync: async (commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO?: CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shipping/address/validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShippingApi - functional programming interface
 * @export
 */
export const ShippingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShippingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO} [commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shippingGetAddressValidationAsync(commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO?: CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsResponsesShippingAddressValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shippingGetAddressValidationAsync(commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShippingApi - factory interface
 * @export
 */
export const ShippingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShippingApiFp(configuration)
    return {
        /**
         * 
         * @param {CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO} [commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippingGetAddressValidationAsync(commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO?: CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO, options?: any): AxiosPromise<CommercePlatformCartServiceModelsResponsesShippingAddressValidationResponse> {
            return localVarFp.shippingGetAddressValidationAsync(commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShippingApi - object-oriented interface
 * @export
 * @class ShippingApi
 * @extends {BaseAPI}
 */
export class ShippingApi extends BaseAPI {
    /**
     * 
     * @param {CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO} [commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingApi
     */
    public shippingGetAddressValidationAsync(commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO?: CommercePlatformCartServiceModelsDTOsPublicAddressMiniDTO, options?: AxiosRequestConfig) {
        return ShippingApiFp(this.configuration).shippingGetAddressValidationAsync(commercePlatformCartServiceModelsDTOsPublicAddressMiniDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaxRegionApi - axios parameter creator
 * @export
 */
export const TaxRegionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} postal 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxRegionGetAsync: async (postal: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postal' is not null or undefined
            assertParamExists('taxRegionGetAsync', 'postal', postal)
            const localVarPath = `/api/v1/taxregion/{postal}`
                .replace(`{${"postal"}}`, encodeURIComponent(String(postal)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxRegionApi - functional programming interface
 * @export
 */
export const TaxRegionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaxRegionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} postal 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taxRegionGetAsync(postal: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicTaxRegionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taxRegionGetAsync(postal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaxRegionApi - factory interface
 * @export
 */
export const TaxRegionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaxRegionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} postal 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxRegionGetAsync(postal: string, options?: any): AxiosPromise<CommercePlatformCartServiceModelsDTOsPublicTaxRegionDTO> {
            return localVarFp.taxRegionGetAsync(postal, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaxRegionApi - object-oriented interface
 * @export
 * @class TaxRegionApi
 * @extends {BaseAPI}
 */
export class TaxRegionApi extends BaseAPI {
    /**
     * 
     * @param {string} postal 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxRegionApi
     */
    public taxRegionGetAsync(postal: string, options?: AxiosRequestConfig) {
        return TaxRegionApiFp(this.configuration).taxRegionGetAsync(postal, options).then((request) => request(this.axios, this.basePath));
    }
}



